import Vue from 'vue';
import VueCookies from 'vue-cookies';

Vue.use(VueCookies);

export default {
    ADD_VIEWED_OFFER: (state, payload) => {
        const isOfferIdInViewedOffersIds = state.viewedOffersIds.includes(payload.id);

        if (isOfferIdInViewedOffersIds) {
            return;
        }

        state.viewedOffersIds.push(payload.id);
        Vue.$cookies.set('viewedOffersIds', JSON.stringify(state.viewedOffersIds), '7d');
    }
};
